module.exports = __webpack_public_path__ + "img/beer_id-43.e4d430bd.png";